import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	viewBox: "0 0 1.37656 0.99551",
	fill: "#9095B5",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0.01617 0.59926c-0.02155,-0.02155 -0.02155,-0.05486 0,-0.07641 0.02057,-0.02057 0.05486,-0.02057 0.07543,0l0.34285 0.34285 0.85027 -0.85027c0.02057,-0.02057 0.05486,-0.02057 0.07641,0 0.02057,0.02057 0.02057,0.05486 0,0.07641l-0.88847 0.8875c-0.02155,0.02155 -0.05486,0.02155 -0.07641,0l-0.38008 -0.38008z" })
});
export default SvgIcoCheck;
